import { render, staticRenderFns } from "./Rezervari_list.vue?vue&type=template&id=17380ce2"
import script from "./Rezervari_list.vue?vue&type=script&lang=js"
export * from "./Rezervari_list.vue?vue&type=script&lang=js"
import style0 from "./Rezervari_list.vue?vue&type=style&index=0&id=17380ce2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports